import Text from 'common-components/Text'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { COLORS } from 'consts/colors'
import styled from 'styled-components'

export const NoMusicDndAreaWrapper = styled.div`
  border-radius: 4px;
  border: 1px dashed ${COLORS.borderColor};
  background-color: ${COLORS.fillSubtle};
  align-items: center;
  padding: 24px 0;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: 100%;
  }
`

export const NoMusicDndAreaText = styled(Text)`
  width: 172px;
`

export const SpiderIconWrapper = styled.div`
  margin: 7px 12px;
  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    margin: 0;
  }
`
